import { useState } from "react";
import { Link } from "react-router-dom";
import { Button } from "../components/ui/button";
import { Dialog, DialogContent } from "../components/ui/dialog";
import { ArrowRight, X, ChevronLeft, ChevronRight } from "lucide-react";

const galleryImages = [
  {
    id: 1,
    src: "https://web.archive.org/web/20240515010830im_/https://solar-beton.ro/wp-content/uploads/2021/07/solar-construct08.jpg",
    title: "Proiect Rezidențial",
    category: "Proiecte Finalizate",
    description: "Turnare fundație pentru construcție rezidențială",
  },
  {
    id: 2,
    src: "https://solar-beton.ro/wp-content/uploads/2021/07/solar-construct10-1024x576.jpg",
    title: "Lucrări Infrastructură",
    category: "Proiecte Finalizate",
    description: "Beton turnat pentru proiect de infrastructură",
  },
  {
    id: 3,
    src: "https://solar-beton.ro/wp-content/uploads/2021/07/solar-construct05-1024x576.jpg",
    title: "Platformă Beton",
    category: "În Lucru",
    description: "Realizare platformă din beton",
  },
  {
    id: 4,
    src: "https://solar-beton.ro/wp-content/uploads/2021/07/solar-construct03-1024x576.jpg",
    title: "Fundație Casă",
    category: "Proiecte Finalizate",
    description: "Turnare fundație pentru casă unifamilială",
  },
  {
    id: 5,
    src: "https://solar-beton.ro/wp-content/uploads/2021/07/solar-construct02-1024x576.jpg",
    title: "Construcție Nouă",
    category: "În Lucru",
    description: "Lucrări de beton pentru construcție nouă",
  },
  {
    id: 6,
    src: "https://solar-beton.ro/wp-content/uploads/2021/07/solar-construct04-1024x576.jpg",
    title: "Proiect Industrial",
    category: "Proiecte Finalizate",
    description: "Beton pentru proiect industrial",
  },
  {
    id: 7,
    src: "https://solar-beton.ro/wp-content/uploads/2021/07/solar-construct09-1024x576.jpg",
    title: "Lucrări Speciale",
    category: "În Lucru",
    description: "Turnare beton pentru lucrări speciale",
  },
  {
    id: 8,
    src: "https://web.archive.org/web/20240515010830im_/https://solar-beton.ro/wp-content/uploads/2021/07/solar-construct06.jpg",
    title: "Șantier Activ",
    category: "În Lucru",
    description: "Livrare și turnare beton pe șantier",
  },
  {
    id: 9,
    src: "https://solar-beton.ro/wp-content/uploads/2021/07/solar-construct06-1024x576.jpg",
    title: "Finalizare Proiect",
    category: "Proiecte Finalizate",
    description: "Proiect finalizat cu beton de calitate",
  },
  {
    id: 10,
    src: "https://solar-beton.ro/wp-content/uploads/2020/07/proiect1.jpg",
    title: "Proiect 2020",
    category: "Proiecte Finalizate",
    description: "Lucrare finalizată în 2020",
  },
  {
    id: 11,
    src: "https://solar-beton.ro/wp-content/uploads/2020/07/proiect1-1.jpg",
    title: "Detaliu Proiect",
    category: "Proiecte Finalizate",
    description: "Detaliu turnare beton",
  },
  {
    id: 12,
    src: "https://solar-beton.ro/wp-content/uploads/2020/07/proiect2.jpg",
    title: "Proiect Comercial",
    category: "Proiecte Finalizate",
    description: "Beton pentru spațiu comercial",
  },
];

const categories = ["Toate", "Proiecte Finalizate", "În Lucru"];

export const Gallery = () => {
  const [selectedCategory, setSelectedCategory] = useState("Toate");
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  const filteredImages = selectedCategory === "Toate" 
    ? galleryImages 
    : galleryImages.filter(img => img.category === selectedCategory);

  const openLightbox = (index) => {
    setCurrentImageIndex(index);
    setLightboxOpen(true);
  };

  const nextImage = () => {
    setCurrentImageIndex((prev) => (prev + 1) % filteredImages.length);
  };

  const prevImage = () => {
    setCurrentImageIndex((prev) => (prev - 1 + filteredImages.length) % filteredImages.length);
  };

  return (
    <div className="pt-20" data-testid="gallery-page">
      {/* Hero Section */}
      <section className="py-24 md:py-32 bg-[#FAFAFA] border-b border-[#D4D4D4]" data-testid="gallery-hero">
        <div className="px-6 md:px-12 lg:px-24">
          <div className="max-w-4xl">
            <p className="text-xs font-bold tracking-[0.2em] uppercase text-[#FACC15] mb-4">
              Galerie
            </p>
            <h1 className="text-5xl sm:text-6xl font-black tracking-tighter uppercase mb-6">
              PROIECTELE<br />NOASTRE
            </h1>
            <p className="text-lg text-[#737373] max-w-2xl font-medium leading-relaxed">
              Explorați galeria noastră pentru a vedea câteva din proiectele la care am contribuit cu beton de calitate.
            </p>
          </div>
        </div>
      </section>

      {/* Category Filter */}
      <section className="py-8 bg-white border-b border-[#D4D4D4]" data-testid="gallery-filter">
        <div className="px-6 md:px-12 lg:px-24">
          <div className="flex flex-wrap gap-4">
            {categories.map((category) => (
              <button
                key={category}
                onClick={() => setSelectedCategory(category)}
                className={`px-6 py-3 text-xs font-bold tracking-[0.1em] uppercase transition-colors border ${
                  selectedCategory === category
                    ? "bg-[#0A0A0A] text-white border-[#0A0A0A]"
                    : "bg-white text-[#0A0A0A] border-[#D4D4D4] hover:border-[#0A0A0A]"
                }`}
                data-testid={`filter-${category.toLowerCase().replace(/\s+/g, '-')}`}
              >
                {category}
              </button>
            ))}
          </div>
        </div>
      </section>

      {/* Gallery Grid - Bento Layout */}
      <section className="py-16 md:py-24 bg-white" data-testid="gallery-grid">
        <div className="px-6 md:px-12 lg:px-24">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-1">
            {filteredImages.map((image, index) => (
              <div
                key={image.id}
                className={`relative group cursor-pointer overflow-hidden ${
                  index === 0 ? "lg:col-span-2 lg:row-span-2" : ""
                }`}
                onClick={() => openLightbox(index)}
                data-testid={`gallery-item-${image.id}`}
              >
                <div className={`aspect-square ${index === 0 ? "lg:aspect-auto lg:h-full" : ""}`}>
                  <img
                    src={image.src}
                    alt={image.title}
                    className="w-full h-full object-cover grayscale group-hover:grayscale-0 transition-all duration-500"
                  />
                </div>
                <div className="absolute inset-0 bg-black/0 group-hover:bg-black/60 transition-all duration-300 flex items-end p-6">
                  <div className="translate-y-full group-hover:translate-y-0 transition-transform duration-300">
                    <p className="text-xs font-bold tracking-[0.1em] uppercase text-[#FACC15] mb-1">
                      {image.category}
                    </p>
                    <h3 className="text-xl font-bold text-white">{image.title}</h3>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Lightbox */}
      <Dialog open={lightboxOpen} onOpenChange={setLightboxOpen}>
        <DialogContent className="max-w-5xl bg-black border-none p-0 rounded-none" data-testid="lightbox">
          <button
            onClick={() => setLightboxOpen(false)}
            className="absolute top-4 right-4 z-10 p-2 bg-white/10 hover:bg-white/20 transition-colors"
            data-testid="lightbox-close"
          >
            <X className="w-6 h-6 text-white" />
          </button>
          
          <button
            onClick={prevImage}
            className="absolute left-4 top-1/2 -translate-y-1/2 z-10 p-2 bg-white/10 hover:bg-white/20 transition-colors"
            data-testid="lightbox-prev"
          >
            <ChevronLeft className="w-8 h-8 text-white" />
          </button>
          
          <button
            onClick={nextImage}
            className="absolute right-4 top-1/2 -translate-y-1/2 z-10 p-2 bg-white/10 hover:bg-white/20 transition-colors"
            data-testid="lightbox-next"
          >
            <ChevronRight className="w-8 h-8 text-white" />
          </button>

          {filteredImages[currentImageIndex] && (
            <div className="relative">
              <img
                src={filteredImages[currentImageIndex].src}
                alt={filteredImages[currentImageIndex].title}
                className="w-full h-auto max-h-[80vh] object-contain"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/80 to-transparent p-6">
                <p className="text-xs font-bold tracking-[0.1em] uppercase text-[#FACC15] mb-1">
                  {filteredImages[currentImageIndex].category}
                </p>
                <h3 className="text-xl font-bold text-white mb-2">
                  {filteredImages[currentImageIndex].title}
                </h3>
                <p className="text-white/60 text-sm">
                  {filteredImages[currentImageIndex].description}
                </p>
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>

      {/* CTA Section */}
      <section className="py-24 md:py-32 bg-[#FACC15]" data-testid="gallery-cta">
        <div className="px-6 md:px-12 lg:px-24 text-center">
          <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mb-6 text-[#0A0A0A]">
            VREI SĂ FII URMĂTORUL PROIECT?
          </h2>
          <p className="text-lg text-[#0A0A0A]/80 mb-8 max-w-2xl mx-auto">
            Contactează-ne pentru o ofertă personalizată. Suntem gata să contribuim la succesul proiectului tău.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button 
              asChild
              className="bg-[#0A0A0A] text-white hover:bg-[#171717] rounded-none font-bold tracking-wider uppercase text-sm px-8 py-6"
              data-testid="gallery-services-btn"
            >
              <Link to="/servicii">
                Vezi Prețurile
                <ArrowRight className="ml-2 w-4 h-4" />
              </Link>
            </Button>
            <Button 
              asChild
              variant="outline"
              className="bg-transparent border-2 border-[#0A0A0A] text-[#0A0A0A] hover:bg-[#0A0A0A] hover:text-white rounded-none font-bold tracking-wider uppercase text-sm px-8 py-6"
              data-testid="gallery-contact-btn"
            >
              <Link to="/contact">
                Contactează-ne
              </Link>
            </Button>
          </div>
        </div>
      </section>
    </div>
  );
};
